import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const announcementId = this.element.dataset.announcementId
    if (announcementId && this.isDismissed(announcementId)) {
      this.element.remove()
    }
  }

  dismiss() {
    const announcementId = this.element.dataset.announcementId
    if (announcementId) {
      this.markDismissed(announcementId)
    }
    this.element.remove()
  }

  isDismissed(id) {
    const dismissed = this.getDismissedIds()
    return dismissed.includes(id)
  }

  markDismissed(id) {
    const dismissed = this.getDismissedIds()
    if (!dismissed.includes(id)) {
      dismissed.push(id)
      localStorage.setItem("dismissed_announcements", JSON.stringify(dismissed))
    }
  }

  getDismissedIds() {
    try {
      return JSON.parse(localStorage.getItem("dismissed_announcements")) || []
    } catch {
      return []
    }
  }
}
